module.exports = __webpack_public_path__ + "static/media/tracking_link_ad_1.60b773d7.png";